<!-- Summary step component -->
<div #summaryStep class="summary custom-scrollbar">
    <div *ngIf="appDataTemp.customerapp" class="summary__card summary__card_client">
        <!-- Client image -->
        <div class="card__header">
            <div class="card__title">
                <span class="client__name">
                    {{ appDataTemp.customerapp.fl }}
                </span>

                <span *ngIf="appDataTemp.customerapp.age > 0 || appDataTemp.customerapp.sex" class="client__info">
                    (<span *ngIf="appDataTemp.customerapp.age > 0">{{ appDataTemp.customerapp.age }}, </span>
                    <span *ngIf="appDataTemp.customerapp.sex == 1">לא מוגדר</span>
                    <span *ngIf="appDataTemp.customerapp.sex == 2">אישה</span>
                    <span *ngIf="appDataTemp.customerapp.sex == 3">גבר</span>)
                </span>
            </div>
        </div>

        <!-- Client tags -->
        <div class="card__body">
            <div class="client__content">
                <div class="client__image-wrapper">
                    <span class="client__vip fa-solid fa-heart" [ngClass]="{ client__vip_active: appDataTemp.customerapp.isVip }"></span>
                    <img class="client__image" [src]="getClientImageSrc()" (error)="clearImagePath()" alt="Client picture" />
                </div>

                <div class="client__details">
                    <div *ngIf="appDataTemp.customerapp.isBirthDay || appDataTemp.customerapp.isDebt" class="client__badges">
                        <div *ngIf="appDataTemp.customerapp.isDebt" class="client__badge badge_debt">
                            <i class="badge__icon fa-duotone fa-coins"></i>
                            חוב {{ appDataTemp.customerapp.collectDebt }} ₪
                        </div>

                        <div *ngIf="appDataTemp.customerapp.isBirthDay" class="client__badge badge_birthday">
                            <i class="badge__icon fa-regular fa-cake-candles"></i>
                            יום הולדת {{ appDataTemp.customerapp.birthDay }}/{{ appDataTemp.customerapp.birthMonth }}
                        </div>
                    </div>

                    <div
                        *ngIf="appDataTemp.customerapp.customerId == -99999 && !appDataTemp.forceCreateCustomer"
                        class="client__badge badge_new-client"
                    >
                        <i class="badge__icon fa-regular fa-user-plus"></i>
                        לקוח/ה לא במאגר
                    </div>

                    <p *ngIf="appDataTemp.customerapp.comments" class="client__text custom-scrollbar">{{ appDataTemp.customerapp.comments }}</p>
                    <p
                        *ngIf="!appDataTemp.customerapp.comments && appDataTemp.customerapp.customerId != -99999"
                        class="client__text client__text_empty"
                    >
                        אין עדיין הערות בכרטיס הלקוח/ה
                    </p>
                    <p *ngIf="appDataTemp.customerapp.customerId == -99999" class="client__text client__text_new-client">
                        יהיה ניתן להוסיף הערות קבועות ללקוח/ה רק אחרי הוספתו למאגר
                    </p>
                </div>
            </div>
        </div>

        <div *ngIf="appDataTemp.customerapp.isHaveCancelAppointments" class="card__footer">
            <i class="client__warning-icon fa-solid fa-triangle-exclamation"></i>
            <span class="client__warning-text"> {{ appDataTemp.customerapp.cCount }} ביטולים בשנה האחרונה </span>
        </div>

        <div *ngIf="appDataTemp.customerapp.customerId == -99999 && appDataTemp.forceCreateCustomer" class="card__footer card__footer_success">
            <i class="client__success-icon fa-solid fa-circle-check"></i>
            <span class="client__success-text">הלקוח/ה ייכנס למאגר בסיום קביעת התור</span>
        </div>
    </div>

    <div class="summary__card summary__card_time">
        <!-- Event date details -->
        <div class="card__header">
            <div class="card__title">
                <span class="time__icon">
                    <i class="fa-regular fa-calendar-lines"></i>
                </span>

                {{ appDataTemp?.start | date : "dd/MM/yyyy EEE" }}
            </div>

            <span *ngIf="holidayName" class="card__info time__info">
                {{ holidayName }}
            </span>
        </div>

        <div class="card__body">
            <div class="time__content">
                <!-- Time edit button -->
                <button class="time__edit-button button button_size_small button_theme_main-line" [disabled]="isTimeEditing" (click)="editTime()">
                    <i class="fa-regular fa-pen"></i>
                    עריכת שעות
                </button>

                <!-- Inputs that have start and end time -->
                <div class="time__inputs">
                    <div class="time__input-wrapper input-wrapper input-wrapper_with-label">
                        <span class="input-label">התחלה</span>
                        <input
                            class="time__input input"
                            [ngClass]="{ time__input_selected: isTimeEditing && activeTimepicker == 'start' }"
                            [value]="startTime"
                            [disabled]="!isTimeEditing"
                            readonly
                            (click)="chooseStartOrEndTimepicker('start')"
                        />
                    </div>

                    <div class="time__input-wrapper input-wrapper input-wrapper_with-label">
                        <span class="input-label">סיום</span>
                        <input
                            class="time__input input"
                            [ngClass]="{ time__input_selected: isTimeEditing && activeTimepicker == 'end' }"
                            [value]="endTime"
                            [disabled]="!isTimeEditing"
                            readonly
                            (click)="chooseStartOrEndTimepicker('end')"
                        />
                    </div>
                </div>

                <!-- Start timepicker -->
                <mbsc-datepicker
                    *ngIf="activeTimepicker == 'start' && isTimeEditing"
                    [options]="options"
                    [controls]="['time']"
                    display="inline"
                    class="timepicker"
                    [(ngModel)]="startTimepickerValue"
                    [stepMinute]="configDiary?.calScaleInMin"
                    itemHeight="30"
                    [invalid]="startInvalid"
                    (onChange)="onTimeChange('start')"
                >
                </mbsc-datepicker>

                <!-- End timepicker -->
                <mbsc-datepicker
                    *ngIf="activeTimepicker == 'end' && isTimeEditing"
                    [options]="options"
                    [controls]="['time']"
                    display="inline"
                    class="timepicker"
                    [(ngModel)]="endTimepickerValue"
                    [stepMinute]="configDiary?.calScaleInMin"
                    itemHeight="30"
                    [invalid]="endInvalid"
                    (onChange)="onTimeChange('end')"
                >
                </mbsc-datepicker>

                <div *ngIf="isTimeEditing" class="time__buttons">
                    <button class="time__close-button button button_size_small button_theme_gray-line" (click)="closeEditingTime()">ביטול</button>

                    <button class="time__save-button button button_size_small button_theme_main" (click)="saveEditedTime()">אישור</button>
                </div>
            </div>
        </div>

        <!-- Event duration -->
        <div class="card__footer">
            <i class="time__footer-icon fa-solid fa-clock-nine"></i>
            <span class="time__footer-text">{{ eventDuration }}</span>
        </div>
    </div>

    <!-- Event services -->
    <div *ngIf="appDataTemp.subserv" class="summary__card summary__card_services">
        <div class="card__header">
            <div class="card__title">טיפולים ({{ appDataTemp.subserv.length }})</div>

            <div *ngIf="appDataTemp.subserv.length > 0" class="card__info services__info">
                <i class="services-info__icon fa-regular fa-coins"></i>
                <span class="services-info__text">₪{{ getServicesPrice() }}</span>
            </div>
        </div>

        <div class="card__body">
            <div class="services__list custom-scrollbar">
                <div *ngFor="let item of appDataTemp.subserv" class="services__item">
                    <div class="services-item__name">
                        {{ item.serviceName }}

                        <div *ngIf="item.subT" class="services-item__subscription">
                            <img class="subscription__icon" src="/assets/img/ticket.svg" />
                            <span class="subscription__text">{{ item.sub }}/{{ item.subT }}</span>
                        </div>
                    </div>

                    <div class="services-item__price">
                        <i class="services-item__icon fa-regular fa-coins"></i>
                        ₪{{ item.priceService }}
                    </div>

                    <div *ngIf="item.subT" class="services-item__subscription services-item__subscription_mobile">
                        <img class="subscription__icon" src="/assets/img/ticket.svg" />
                        <span class="subscription__text">{{ item.sub }}/{{ item.subT }}</span>
                    </div>
                </div>
            </div>

            <div *ngIf="!appDataTemp.subserv.length" class="services__empty">
                <span class="empty__text">לא נבחרו טיפולים</span>
                <img class="empty__image" src="/assets/img/no-services.svg" />
            </div>
        </div>
    </div>

    <!-- Event comment -->
    <div class="summary__card summary__card_description">
        <div class="card__header">
            <div class="card__title">הערות לתור</div>
        </div>

        <div class="card__body">
            <div class="input-wrapper input-wrapper_type_textarea description__input-wrapper">
                <textarea class="input" [(ngModel)]="appDataTemp.remark" placeholder="הוסף הערות..." autocomplete="off"></textarea>
            </div>
        </div>
    </div>

    <!-- Dropdowns -->
    <div *ngIf="resources && statusesAppointment" class="summary__card summary__card_resourses">
        <div class="card__header">
            <div class="card__title">פרטים נוספים</div>
        </div>

        <div class="card__body">
            <div class="resources__content">
                <div class="resources__select-wrapper" style="pointer-events: none">
                    <span class="resources__label">מטפל</span>

                    <div class="resources__button-wrapper">
                        <mbsc-button class="resources__button" [options]="options" (click)="toggleResourceList()" disabled>
                            <img class="button__icon" src="{{ getResourceImage(selectedResource?.imagePath) }}" />
                            <span class="button__name">{{ selectedResource?.name }}</span>
                        </mbsc-button>
                    </div>

                    <div class="resources__list" [ngClass]="{ resources__list_opened: isResourceListOpened }">
                        <div class="resources__option" *ngFor="let resource of resources" (click)="chooseResource(resource)">
                            <img class="option__icon" src="{{ getResourceImage(resource.imagePath) }}" />
                            <span class="option__name">{{ resource.name }}</span>
                        </div>
                    </div>
                </div>

                <div class="resources__select-wrapper">
                    <span class="resources__label">סטטוס התור</span>

                    <div class="resources__button-wrapper">
                        <mbsc-button class="resources__button resources__button_status" [options]="options" (click)="toggleStatusList()">
                            <img *ngIf="selectedStatus?.indEv != 4 && selectedStatus?.imagePath" class="button__icon" src="/assets/img/{{ selectedStatus?.imagePath }}" />
                            <span class="button__name">{{ selectedStatus?.nameEvHeb }}</span>
                        </mbsc-button>
                    </div>

                    <div class="resources__list" [ngClass]="{ resources__list_opened: isStatusListOpened }">
                        <div
                            class="resources__option resources__option_status"
                            *ngFor="let status of statusesAppointment"
                            (click)="chooseStatus(status)"
                        >
                            <img *ngIf="status.indEv != 4" class="option__icon" src="/assets/img/{{ status.imagePath }}" />
                            <span *ngIf="status.indEv == 4" class="option__icon"></span>
                            <span class="option__name">{{ status.nameEvHeb }}</span>
                        </div>
                    </div>
                </div>

                <div class="resources__select-wrapper">
                    <span class="resources__label">קובע התור</span>

                    <div
                        class="resources__button-wrapper"
                        [ngClass]="{ 'resources__button-wrapper_error': isAppointorErrorVisible && !appDataTemp.appointorId }"
                    >
                        <mbsc-button *ngIf="selectedAppointor" class="resources__button" [options]="options" (click)="toggleAppointorList()">
                            <img class="button__icon" src="{{ getResourceImage(selectedAppointor?.imagePath) }}" />
                            <span class="button__name">{{ selectedAppointor?.name }}</span>
                        </mbsc-button>

                        <mbsc-button *ngIf="!selectedAppointor" class="resources__button" [options]="options" (click)="toggleAppointorList()">
                            <span class="button__name">בחר</span>
                        </mbsc-button>
                    </div>

                    <div class="resources__list" [ngClass]="{ resources__list_opened: isAppointorListOpened }">
                        <div class="resources__option" (click)="chooseAppointor(null)">
                            <span class="option__icon"></span>
                            <span class="option__name">בחר</span>
                        </div>

                        <div class="resources__option" *ngFor="let resource of resources" (click)="chooseAppointor(resource)">
                            <img class="option__icon" src="{{ getResourceImage(resource.imagePath) }}" />
                            <span class="option__name">{{ resource.name }}</span>
                        </div>
                    </div>

                    <span *ngIf="isAppointorErrorVisible && !appDataTemp.appointorId" class="resources__error">חובה לבחור את קובע/ת התור</span>
                </div>

                <div *ngIf="isResourceListOpened" class="resources__background" (click)="toggleResourceList()"></div>
                <div *ngIf="isStatusListOpened" class="resources__background" (click)="toggleStatusList()"></div>
                <div *ngIf="isAppointorListOpened" class="resources__background" (click)="toggleAppointorList()"></div>
            </div>

            <div *ngIf="isEditingEvent" class="resources__creation">
                הפגישה נוצרה ע״י: {{ creationAppointor?.name }} בתאריך {{ appDataTemp?.creationDate | date : "dd/MM/yyyy 'בשעה' HH:mm " }}
            </div>
        </div>
    </div>
</div>
